import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useI18n } from "../i18n";
import { fetchCars } from "../api";
import CarCard from "../components/CarCard";
import TrustBadges from "../components/TrustBadges";

const Fleet = () => {
  const { t } = useI18n();
  const [searchParams] = useSearchParams();
  const initialCat = searchParams.get("cat") || "all";
  const [cars, setCars] = useState([]);
  const [filter, setFilter] = useState(initialCat);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchCars()
      .then((data) => setCars(data))
      .catch(() => setCars([]))
      .finally(() => setLoading(false));
  }, []);

  const categories = ["all", "economy", "compact", "midsize", "suv", "minivan", "van"];
  const visible =
    filter === "all" ? cars : cars.filter((c) => c.category === filter);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="fleet-page">
      <p className="text-label text-[#FFB400]">
        <span className="line-accent" />
        {t.fleet.eyebrow}
      </p>
      <h1
        className="mt-4 font-heading text-5xl sm:text-6xl font-bold tracking-tighter text-white max-w-3xl"
        data-testid="fleet-title"
      >
        {t.fleet.title}
      </h1>

      <div className="mt-10">
        <TrustBadges compact />
      </div>

      <div
        className="mt-12 flex flex-wrap gap-2 border-b border-white/10 pb-4"
        data-testid="fleet-filters"
      >
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setFilter(cat)}
            data-testid={`filter-${cat}`}
            className={`px-5 py-2.5 text-xs font-mono-ui uppercase tracking-widest border transition-all ${
              filter === cat
                ? "border-[#FFB400] bg-[#FFB400] text-white"
                : "border-white/10 text-zinc-400 hover:border-white/30 hover:text-white"
            }`}
          >
            {t.fleet.filters[cat]}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="fleet-grid">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="aspect-[5/6] bg-[#0d0d0d] border border-white/5 animate-pulse"
              />
            ))
          : visible.map((c) => <CarCard key={c.id} car={c} />)}
      </div>

      {!loading && visible.length === 0 && (
        <p className="mt-20 text-center text-zinc-500" data-testid="fleet-empty">
          No cars in this category yet.
        </p>
      )}
    </div>
  );
};

export default Fleet;
